module.exports = __webpack_public_path__ + "static/charles-levoir-83a7db4f6c39537bfc9d01735289509a.png";